import { render } from "./InstituteTargetDrawer.vue?vue&type=template&id=4fada9c3&ts=true"
import script from "./InstituteTargetDrawer.vue?vue&type=script&lang=ts"
export * from "./InstituteTargetDrawer.vue?vue&type=script&lang=ts"

import "./InstituteTargetDrawer.vue?vue&type=style&index=0&id=4fada9c3&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__